import React from "react";

const IntroPage = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-[70px] w-[100vw] h-[100vh] text-white bg-main">
      <div className="w-[861px] font-medium text-[30px] text-center leading-[50px] tracking-[8px]">
        In 2020, about 1 out of 3 people perceived Korean food as spicy.
      </div>
      <div className="w-[861px] font-medium text-[30px] text-center leading-[50px] tracking-[8px]">
        In 2021, More than 40% people perceived Korean food as flavorful.
      </div>
    </div>
  );
};

export default IntroPage;
